import { render, staticRenderFns } from "./itemStudy.vue?vue&type=template&id=6a57d454&scoped=true"
import script from "./itemStudy.vue?vue&type=script&lang=js"
export * from "./itemStudy.vue?vue&type=script&lang=js"
import style0 from "./itemStudy.vue?vue&type=style&index=0&id=6a57d454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57d454",
  null
  
)

export default component.exports